import { AbstractGlobalDataCommand } from "./abstractGlobalDataCommand";

export class LocalizeCommand extends AbstractGlobalDataCommand {
  languageCode?: string;
}